function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "15pt",
    height: "17pt",
    viewBox: "0 0 15 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(15.294118%,20.784314%,51.372549%)",
      fillOpacity: 1
    },
    d: "M 7.628906 17.125 C 6.425781 17.125 5.449219 16.164062 5.449219 14.984375 L 9.808594 14.984375 C 9.808594 15.550781 9.578125 16.097656 9.171875 16.5 C 8.761719 16.898438 8.207031 17.125 7.628906 17.125 Z M 0.292969 12.117188 C 0.949219 11.421875 2.183594 10.378906 2.183594 6.957031 C 2.179688 4.425781 4.007812 2.246094 6.539062 1.765625 L 6.539062 1.070312 C 6.539062 0.480469 7.027344 0 7.628906 0 C 8.230469 0 8.71875 0.480469 8.71875 1.070312 L 8.71875 1.765625 C 11.25 2.246094 13.078125 4.425781 13.074219 6.957031 C 13.074219 10.378906 14.304688 11.425781 14.964844 12.117188 C 15.152344 12.3125 15.257812 12.574219 15.257812 12.84375 C 15.253906 13.128906 15.140625 13.402344 14.9375 13.601562 C 14.730469 13.800781 14.453125 13.914062 14.164062 13.914062 L 1.09375 13.914062 C 0.804688 13.914062 0.527344 13.800781 0.320312 13.601562 C 0.117188 13.402344 0 13.128906 0 12.84375 C 0 12.574219 0.105469 12.3125 0.292969 12.117188 Z M 0.292969 12.117188 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.94e15f5b9870fd3dcf3e7ab1126930b8.svg";
export { ForwardRef as ReactComponent };